export default __webpack_public_path__ + "static/media/bg-agent-2.ef0cd1f8.png";